export type INormalizeText = (str: string, accentMap?: IDCA.IGenericObj) => string;

export function normalizeText(str: string, accentMap?: IDCA.IGenericObj): string {
  const _accentMap = accentMap || window.DexeroCoreApp.userOptions.accentMap || {};
  return str
    .split('')
    .map(character => _accentMap[character] || character)
    .join('')
    .toLowerCase();
}
